import {HostMaps} from 'hiya-common/src/utils/host/AutoHost'
import {BoardItem, WildStateStatus, BoardCardEnum} from './interface'
import selectImg from './images/newCard/选中.png'
import unselectImg from './images/newCard/默认.png'
import wildImg from './images/newCard/10.png'

export const getPreImgs = () => {
  const homeContext = require.context('./images/home', false, /.png$/)
  const homeHeaerContext = require.context(
    './images/home/header',
    false,
    /.png$/
  )
  const homeBottomContext = require.context(
    './images/home/bottom',
    false,
    /.png$/
  )
  const homeMainContext = require.context('./images/home/main', false, /.png$/)
  const homePoolContext = require.context('./images/home/pool', false, /.png$/)
  const cardContext = require.context('./images/newCard', false, /.png$/)
  const preApngContext = require.context('./images/apng/before', false, /.png$/)
  const freePlayContext = require.context(
    './images/free-play-modal',
    false,
    /.png$/
  )

  return [
    ...homeContext.keys().map(homeContext),
    ...homeHeaerContext.keys().map(homeHeaerContext),
    ...homeBottomContext.keys().map(homeBottomContext),
    ...homeMainContext.keys().map(homeMainContext),
    ...homePoolContext.keys().map(homePoolContext),
    ...cardContext.keys().map(cardContext),
    ...preApngContext.keys().map(preApngContext),
    ...freePlayContext.keys().map(freePlayContext),
  ] as string[]
}

export const getAfterImgs = () => {
  const afterApngContext = require.context(
    './images/apng/after',
    false,
    /.png$/
  )
  const rewardContext = require.context('./images/reward-modal', false, /.png$/)
  const rewardApngContext = require.context(
    './images/reward-modal/apng',
    false,
    /.png$/
  )

  return [
    ...afterApngContext.keys().map(afterApngContext),
    ...rewardContext.keys().map(rewardContext),
    ...rewardApngContext.keys().map(rewardApngContext),
  ] as string[]
}

// 下落最终坐标点 px单位
// left + 66
// top + 84
// 根据给出的x,y 计算坐标点
export const getFinalXY = (x, y) => {
  const rows = 4 // 行
  const cols = 5 // 列
  const startTop = 4 // 初始top
  const startLeft = 0 // 初始left
  const stepTop = 84 // +top
  const stepLeft = 66 // +left
  const FinalXY = Array.from({length: rows}, (_, row) =>
    Array.from({length: cols}, (__, col) => ({
      top: startTop + row * stepTop,
      left: startLeft + col * stepLeft,
    }))
  )
  return FinalXY[x][y]
}

export const getCardBoardSrc = (board: BoardItem) => {
  //  require.context构建时的 静态分析，不能使用运行时变量srcName
  const numPng = require.context(`./images/newCard`, false)
  const src = numPng.keys().find((v) => v === `./${board.id}.png`)
  return src && numPng(src)
}

export const getCardBgSrc = (board: BoardItem) => {
  //  require.context构建时的 静态分析，不能使用运行时变量srcName
  if (board.wild_state === WildStateStatus.wild形态1) {
    return selectImg
  }
  if (board.wild_state === WildStateStatus.普通) {
    return unselectImg
  }
  return wildImg
}

// wild_transforms winning_coords 去重复
export const excludeSubset = (source, subset) => {
  if (!Array.isArray(source)) return []
  if (!Array.isArray(subset) || subset.length === 0) return source

  // 深度比较两个元素是否相等
  const isEqual = (a, b) => {
    if (a === b) return true
    if (Array.isArray(a) && Array.isArray(b)) {
      return (
        a.length === b.length && a.every((val, idx) => isEqual(val, b[idx]))
      )
    }
    if (
      typeof a === 'object' &&
      typeof b === 'object' &&
      a !== null &&
      b !== null
    ) {
      const keysA = Object.keys(a)
      const keysB = Object.keys(b)
      return (
        keysA.length === keysB.length &&
        keysA.every((key) => isEqual(a[key], b[key]))
      )
    }
    return false
  }

  return source.filter((item) => !subset.some((sub) => isEqual(item, sub)))
}

// 判断两种情况
// 1.pre为0| undefined | null cur大于0，既获得次数
// 2.pre大于0，cur为0| undefined | null, 既失去次数
export const judgeSpinChange = (
  pre: number | undefined | null,
  cur: number | undefined | null
): 'gain' | 'lose' | undefined => {
  const preVal = pre ?? 0 // 如果 pre 是 undefined 或 null，视为 0
  const curVal = cur ?? 0 // 如果 cur 是 undefined 或 null，视为 0

  if (preVal === 0 && curVal > 0) {
    return 'gain' // 获得次数
  }

  if (preVal > 0 && curVal === 0) {
    return 'lose' // 失去次数
  }

  return undefined // 无变化
}

// 本地存放历史下注额
export const getLocalBetNum = (mid: string) => {
  const betNum = localStorage.getItem(`royalwild_betnum_${mid}`) ?? 0
  return betNum ? parseInt(betNum, 10) : 0
}

export const setLocalBetNum = (num: number, mid: string) => {
  localStorage.setItem(`royalwild_betnum_${mid}`, `${num}`)
}

// 判断坐标是否在这个二维数组内
export const judgeXYIsInArray = (x, y, arr) => {
  return arr?.some(([a, b]) => a === x && b === y)
}

export const getBetweenRandom = (min, max) => {
  return Math.floor(Math.random() * (max - min) + min)
}

// 本地存放历史音乐设置
export const getLocalMusic = () => {
  const musicStatus =
    (localStorage.getItem(`royalwild_playmusic`) ?? `true`) === 'true'
  return musicStatus
}

export const setLocalMusic = (status: boolean) => {
  localStorage.setItem(`royalwild_playmusic`, `${status}`)
}

export const getNowDate = () => {
  const now = new Date()
  const year = now.getFullYear()
  const month = String(now.getMonth() + 1).padStart(2, '0')
  const day = String(now.getDate()).padStart(2, '0')
  const dateStr = `${year}-${month}-${day}`
  return dateStr
}

// 本地存放历史音乐设置
export const getLocalNewTask = () => {
  const musicStatus = localStorage.getItem(`royalwild_newTask`)
  return musicStatus
}

export const setLocalNewTask = () => {
  const dateStr = getNowDate()
  localStorage.setItem(`royalwild_newTask`, `${dateStr}`)
}

export const GameMusic = {
  background: `${HostMaps.prod.img01}/download/file?obj=mefile/hyfo/80/a9/02de-8a20-11f0-8a87-00163e04069f`,
  holdSpinInit: `${HostMaps.prod.img01}/download/file?obj=mefile/hyfo/3e/6c/7ddd-8a23-11f0-845c-00163e0442bb`,
  cardScroll: `${HostMaps.prod.img01}/download/file?obj=mefile/hyfo/d9/98/9918-8a24-11f0-845c-00163e0442bb`,
  cardCancel: `${HostMaps.prod.img01}/download/file?obj=mefile/hyfo/14/90/e294-8a25-11f0-8a87-00163e04069f`,
  winCoins: `${HostMaps.prod.img01}/download/file?obj=mefile/hyfo/a8/be/486f-8a28-11f0-845c-00163e0442bb`,
  smallWinCoins: `${HostMaps.prod.img01}/download/file?obj=mefile/hyfo/be/98/934d-8a28-11f0-845c-00163e0442bb`,
  bigWin: `${HostMaps.prod.img01}/download/file?obj=mefile/hyfo/77/20/ab9d-8a29-11f0-845c-00163e0442bb`,
  epicWin: `${HostMaps.prod.img01}/download/file?obj=mefile/hyfo/90/77/49eb-8a29-11f0-8a87-00163e04069f`,
  hugeWin: `${HostMaps.prod.img01}/download/file?obj=mefile/hyfo/ab/2b/03e8-8a29-11f0-845c-00163e0442bb`,
  jackpotAppear: `${HostMaps.prod.img01}/download/file?obj=mefile/hyfo/e3/5f/3e59-8a29-11f0-8a87-00163e04069f`,
  massiveWin: `${HostMaps.prod.img01}/download/file?obj=mefile/hyfo/01/e4/9b07-8a2a-11f0-8a87-00163e04069f`,
  scatterAppear: `${HostMaps.prod.img01}/download/file?obj=mefile/hyfo/17/6b/6383-8a2a-11f0-845c-00163e0442bb`,
  spinClick: `${HostMaps.prod.img01}/download/file?obj=mefile/hyfo/31/77/6a5b-8a2a-11f0-845c-00163e0442bb`,
  superWin: `${HostMaps.prod.img01}/download/file?obj=mefile/hyfo/43/71/9533-8a2a-11f0-8a87-00163e04069f`,
  ultimateWin: `${HostMaps.prod.img01}/download/file?obj=mefile/hyfo/59/05/db3b-8a2a-11f0-845c-00163e0442bb`,
  cardRotate: `${HostMaps.prod.img01}/download/file?obj=mefile/hyfo/53/bd/b318-8a2c-11f0-8a87-00163e04069f`,
  jackpotWin: `${HostMaps.prod.img01}/download/file?obj=mefile/hyfo/a8/55/9f1c-ae60-11f0-8a87-00163e04069f`,
}

export function mergeRefs<T = any>(...refs: Array<React.Ref<T> | undefined>) {
  return (value: T | null) => {
    refs.forEach((ref) => {
      if (!ref) return
      if (typeof ref === 'function') {
        ref(value)
      } else {
        (ref as React.MutableRefObject<T | null>).current = value
      }
    })
  }
}
